// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1Xq2O","row":"styles_row__3i8Vj"};